import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['cardFields', 'pixFields', 'paymentMethod', 'notCardholder', 'cardholderFields']

  connect() {
    this.togglePaymentFields()
    this.toggleCardholderFields()
  }

  togglePaymentFields() {
    if (!this.hasPaymentMethodTarget) return

    const selected = this.paymentMethodTargets.find(el => el.checked)
    const paymentMethod = selected ? selected.value : ''
    const cardFields = this.cardFieldsTarget
    const pixFields = this.pixFieldsTarget

    if (paymentMethod === 'card') {
      cardFields.classList.remove('hidden')
      pixFields.classList.add('hidden')
      this.enableCardFields(true)
    } else if (paymentMethod === 'pix') {
      cardFields.classList.add('hidden')
      pixFields.classList.remove('hidden')
      this.enableCardFields(false)
    } else {
      cardFields.classList.add('hidden')
      pixFields.classList.add('hidden')
      this.enableCardFields(false)
    }
  }

  enableCardFields(enable) {
    const cardInputs = this.cardFieldsTarget.querySelectorAll('input:not([name="checkout_form[not_cardholder]"])')
    cardInputs.forEach(input => {
      input.disabled = !enable
      if (!enable) {
        input.value = ''
      }
    })
  }

  toggleCardholderFields(event) {
    if (!this.hasCardholderFieldsTarget) return

    const isChecked = this.notCardholderTarget.checked
    const cardholderFields = this.cardholderFieldsTarget

    if (isChecked) {
      cardholderFields.classList.remove('hidden')
      this.addCartValidationToCardholderFields()
    } else {
      cardholderFields.classList.add('hidden')
      this.removeCartValidationFromCardholderFields()
      this.clearCardholderFields()
    }
  }

  clearCardholderFields() {
    const cardholderInputs = this.cardholderFieldsTarget.querySelectorAll('input')
    cardholderInputs.forEach(input => {
      input.value = ''

      if (input.dataset.cartTarget) delete input.dataset.cartTarget

      const action = input.getAttribute('data-action') || ''

      if (action.includes('cart#debouncedValidateOnInput')) {
        const updated = action.replace(/\binput->cart#debouncedValidateOnInput\b/g, '').replace(/\s+/g, ' ').trim()

        if (updated.length) {
          input.setAttribute('data-action', updated)
        } else {
          input.removeAttribute('data-action')
        }
      }
    })
  }

  addCartValidationToCardholderFields() {
    const cardholderInputs = this.cardholderFieldsTarget.querySelectorAll('input')
    cardholderInputs.forEach(input => {
      input.dataset.cartTarget = 'input'
      const existingAction = input.getAttribute('data-action') || ''

      if (!existingAction.includes('cart#debouncedValidateOnInput')) {
        const newAction = existingAction ? `${existingAction} input->cart#debouncedValidateOnInput` : 'input->cart#debouncedValidateOnInput'
        input.setAttribute('data-action', newAction.trim())
      }
    })

    const cartEl = document.getElementById('cart')
    if (cartEl) cartEl.dispatchEvent(new CustomEvent('cart:validate', { bubbles: true }))
  }

  removeCartValidationFromCardholderFields() {
    const cardholderInputs = this.cardholderFieldsTarget.querySelectorAll('input')
    cardholderInputs.forEach(input => {
      if (input.dataset.cartTarget) delete input.dataset.cartTarget

      const action = input.getAttribute('data-action') || ''
      const updated = action.replace(/\binput->cart#debouncedValidateOnInput\b/g, '').replace(/\s+/g, ' ').trim()

      if (updated.length) {
        input.setAttribute('data-action', updated)
      } else {
        input.removeAttribute('data-action')
      }
    })
    const cartEl = document.getElementById('cart')
    if (cartEl) cartEl.dispatchEvent(new CustomEvent('cart:validate', { bubbles: true }))
  }
}
